module.exports = ".Delivery_link{font-size:20px;font-weight:bold;color:#33B575;text-decoration:underline}\n"